import { images } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function WeeklyRates() {
  return (
    <section
      id="weekly"
      aria-labelledby="weekly-rates-heading"
      className="scroll-mt-16 bg-secondary/45 py-16 md:py-20"
    >
      <div className="shell">
        <div className="grid items-center gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-6">
            <Reveal>
              <Eyebrow>More Time to Explore</Eyebrow>
            </Reveal>
            <h2 id="weekly-rates-heading" className="display-lg mt-6">
              <MaskReveal>Weekly RV Stays</MaskReveal>
            </h2>

            <Reveal delay={0.08}>
              <div className="mt-10">
                <p className="eyebrow text-muted-foreground">From</p>
                <p className="font-display mt-2 text-6xl tracking-tight text-primary md:text-7xl">
                  $504
                </p>
                <p className="mt-2 text-sm uppercase tracking-[0.18em] text-muted-foreground">
                  per week
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.12}>
              <p className="mt-8 max-w-xl text-base leading-relaxed text-muted-foreground">
                Planning to explore more of Auburn and the surrounding Sierra Foothills? Weekly
                stays give you more time to enjoy the American River, local trails, Gold Country,
                wineries and Northern California adventures without rushing your trip. Weekly RV
                sites in Auburn CA start at $504.
              </p>
            </Reveal>

            <Reveal delay={0.18}>
              <p className="mt-8 text-sm text-muted-foreground">
                Rates start at $504 and vary based on lot size, location and availability.
              </p>
              <div className="mt-8 flex w-full flex-col gap-3 sm:flex-row sm:flex-wrap">
                <ResortLink variant="solid" href="/reservations/" className="w-full sm:w-auto">
                  Check Weekly Availability
                </ResortLink>
                <ResortLink
                  variant="outline"
                  href="/nearby-attractions/"
                  className="w-full sm:w-auto"
                >
                  Explore Nearby Attractions
                </ResortLink>
              </div>
            </Reveal>
          </div>

          <Reveal className="lg:col-span-6" y={36}>
            <img
              src={images.advExplore}
              alt="Historic Auburn Gold Country near weekly RV stays at Auburn RV Resort"
              width={1400}
              height={1600}
              loading="lazy"
              decoding="async"
              className="aspect-[4/5] w-full object-cover md:aspect-[5/6]"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
